export const SET_EDIT_USER_GROUPS_LOADED = "SET_EDIT_USER_GROUPS_LOADED";

export const setEditUserGroupsLoaded = (editUserGroupsLoaded: boolean) => {
  return {
    editUserGroupsLoaded,
    type: SET_EDIT_USER_GROUPS_LOADED
  };
};
